export const ReturnableTypeEnum = Object.freeze({
  DELIVERY_ORDER: "DELIVERY_ORDER",
  SALES_INVOICE: "SALES_INVOICE",
  NON_INVOICE: "NON_INVOICE",
});
